import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import { copyFindExcursionsStore } from 'entities/excursions/models/copy-find-excursions/copy-find-excursions-store'
import { listExcursionStore } from 'entities/excursions/models/list-excursions/list-excursions-state'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import Header from './components/header/header'
import ListCard from './components/list-card/list-card'
import s from './styles.module.scss'

const Search = observer(() => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const goFilters = () => {
    navigate(RoutingPaths.excursion.filter.path())
  }

  useEffect(() => {
    copyFindExcursionsStore.onSetDataCopy()
  }, [])

  return (
    <div>
      <Header />

      <div className="container">
        <ListCard />

        {!listExcursionStore.loading && (
          <div className={s.wrapper}>
            <div className={s.filterWrapper}>
              <div
                className={s.button}
                onClick={goFilters}
              >
                <AppIcon
                  id={AllIcons.FILTER}
                  className={s.icon}
                  height={12}
                  width={12}
                />

                {t('filters')}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
})

export default Search
